<!--
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: liyong
 * @Date: 2022-08-03 16:54:50
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-07-05 11:55:52
 * @FilePath: /partner.chaoyongtuan.com/src/views/shopManage/shopLibrary/list/tableCells/sampleCell.vue
 *
 * Copyright (c) 2022 by 央选/李勇, All Rights Reserved.
-->
<template>
	<div>
		<div class="claim-status" :class="row.claim === 1 ? 'success' : row.claim === 2 ? 'warning' : 'error'">{{ row.claim_desc }}</div>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin';
export default {
	mixins: [mixin],
};
</script>
<style lang="less" scoped>
.claim-status {
	display: flex;
	align-items: center;

	&::before {
		content: '';
		width: 8px;
		height: 8px;
		border-radius: 50%;
		margin-right: 8px;
	}

	&.success::before {
		background-color: @color-success;
	}

	&.warning::before {
		background-color: @color-warning;
	}

	&.error::before {
		background-color: @color-danger;
	}
}
</style>
